<template>
  <div
    class="collapse-container"
    :id="content.key"
    :style="{
      fontFamily: content.templateStyle.fontFamily || '',
      fontSize: (content.templateStyle.fontSize + 'rem') || '',
      lineHeight: (content.templateStyle.lineHeight + 'rem') || '',
      textIndent: (content.templateStyle.textIndent && typeof content.templateStyle.textIndent === 'string') ? content.templateStyle.textIndent :
        (content.templateStyle.textIndent && typeof content.templateStyle.textIndent === 'number') ? (content.templateStyle.textIndent + 'rem') : '',
      fontWeight: content.templateStyle.fontWeight || '',
      textDecoration: content.templateStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.templateStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.templateStyle.textAlign || '',
      color: content.templateStyle.color || '',
      backgroundColor: content.templateStyle.backgroundColor || '',
      margin: (typeof content.templateStyle.margin === 'number' && (content.templateStyle.margin + 'rem')) || '',
      marginTop: (typeof content.templateStyle.marginTop === 'number' && (content.templateStyle.marginTop + 'rem')) || '',
      marginBottom: (typeof content.templateStyle.marginBottom === 'number' && (content.templateStyle.marginBottom + 'rem')) || '',
      padding: (typeof content.templateStyle.padding === 'number' && (content.templateStyle.padding + 'rem')) || '',
      paddingTop: (typeof content.templateStyle.paddingTop === 'number' && (content.templateStyle.paddingTop + 'rem')) || '',
      paddingBottom: (typeof content.templateStyle.paddingBottom === 'number' && (content.templateStyle.paddingBottom + 'rem')) || '',
      borderRadius: (typeof content.templateStyle.borderRadius === 'number' && (content.templateStyle.borderRadius + 'rem')) || '',
      border: content.templateStyle.border || '',
      borderTop: content.templateStyle.borderTop || '',
      borderBottom: content.templateStyle.borderBottom || '',
    }"
  >
    <div
      class="collapse-title"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
        marginTop: (typeof content.titleStyle.marginTop === 'number' && (content.titleStyle.marginTop + 'rem')) || '',
        marginBottom: (typeof content.titleStyle.marginBottom === 'number' && (content.titleStyle.marginBottom + 'rem')) || '',
        padding: (typeof content.titleStyle.padding === 'number' && (content.titleStyle.padding + 'rem')) || '',
        paddingTop: (typeof content.titleStyle.paddingTop === 'number' && (content.titleStyle.paddingTop + 'rem')) || '',
        paddingBottom: (typeof content.titleStyle.paddingBottom === 'number' && (content.titleStyle.paddingBottom + 'rem')) || '',
        borderRadius: (typeof content.titleStyle.borderRadius === 'number' && (content.titleStyle.borderRadius + 'rem')) || '',
        border: content.titleStyle.border || '',
        borderTop: content.titleStyle.borderTop || '',
        borderBottom: content.titleStyle.borderBottom || '',
      }"
      @click="collapseHandle"
    >
      <div class="title-text">{{ content.title }}</div>
      <div class="title-icon" :class="collapseVisible ? 'title-icon-open' : ''"></div>
    </div>
    <div
      class="collapse-content"
      :class="collapseVisible ? 'collapse-content-open' : ''"
      :style="{
        fontFamily: content.contentStyle.fontFamily || '',
        fontSize: (content.contentStyle.fontSize + 'rem') || '',
        lineHeight: (content.contentStyle.lineHeight + 'rem') || '',
        textIndent: (content.contentStyle.textIndent && typeof content.contentStyle.textIndent === 'string') ? content.contentStyle.textIndent :
          (content.contentStyle.textIndent && typeof content.contentStyle.textIndent === 'number') ? (content.contentStyle.textIndent + 'rem') : '',
        fontWeight: content.contentStyle.fontWeight || '',
        textDecoration: content.contentStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.contentStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.contentStyle.textAlign || '',
        color: content.contentStyle.color || '',
        backgroundColor: content.contentStyle.backgroundColor || '',
        marginTop: (typeof content.contentStyle.marginTop === 'number' && (content.contentStyle.marginTop + 'rem')) || '',
        marginBottom: (typeof content.contentStyle.marginBottom === 'number' && (content.contentStyle.marginBottom + 'rem')) || '',
        padding: (typeof content.contentStyle.padding === 'number' && (content.contentStyle.padding + 'rem')) || '',
        paddingTop: (typeof content.contentStyle.paddingTop === 'number' && (content.contentStyle.paddingTop + 'rem')) ||
          (typeof content.contentStyle.padding === 'number' && (content.contentStyle.padding + 'rem')) || '',
        paddingBottom: (typeof content.contentStyle.paddingBottom === 'number' && (content.contentStyle.paddingBottom + 'rem')) ||
          (typeof content.contentStyle.padding === 'number' && (content.contentStyle.padding + 'rem')) || '',
        borderRadius: (typeof content.contentStyle.borderRadius === 'number' && (content.contentStyle.borderRadius + 'rem')) || '',
        border: content.contentStyle.border || '',
        borderTop: content.contentStyle.borderTop || '',
        borderBottom: content.contentStyle.borderBottom || '',
      }"
    >
      <commonIndex :bookContent="content.content"></commonIndex>
    </div>
  </div>
</template>

<script>
/*
可收起
*/
export default {
  name: "collapse",
  components: {
    commonIndex: () => import("../../index.vue"), //解决递归加载组件报错
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      collapseVisible: false
    }
  },
  methods: {
    collapseHandle() {
      this.collapseVisible = !this.collapseVisible;
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-container{
  margin: 0 20rem 20rem;
  background: #F0F8F5;

  .collapse-title{
    width: 100%;
    background: #5CA683;
    color: #fff;
    font-size: 26rem;
    line-height: 38rem;
    padding: 16rem 22rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-icon{
      width: 22rem;
      height: 22rem;
      background: url("~@/assets/images/books/book2/collapse-close.png") center center no-repeat;
      background-size: contain;
    }

    .title-icon-open{
      background-image: url("~@/assets/images/books/book2/collapse-open.png");
    }
  }

  .collapse-content{
    height: 0;
    overflow: hidden;
    transition: height 0.2s linear;
  }

  .collapse-content-open{
    height: auto;
  }
}
</style>